import { instance } from '@/services/avik-api-gateway'
import { VehicleTypeGroupPeriod } from '@/types/vehicle-type-group-period'
import { AxiosResponse } from 'axios'

export function getVehicleTypeGroupsPeriod(): Promise<
  AxiosResponse<VehicleTypeGroupPeriod[]>
> {
  return instance.get(`/vehicle-type-group-period`)
}
